import { createReducer, on } from "@ngrx/store";
import {
  fetchAffiliate,
  fetchAffiliateSuccess,
  fetchAffiliateFailure,
  getAffiliate,
  getAffiliateSuccess,
  getAffiliateFailure,
} from "./affiliate.actions";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0, 
  perPage: 0,
  currentPage: 0
};

const _affiliateReducer = createReducer(
  initialState,
  on(fetchAffiliate, (state, { filterOptions }) => {
    return state;
  }),
  on(fetchAffiliateSuccess, (state, { affiliate }) => {
    const payload = {
      isLoaded: true,
      data: affiliate.data,
      total: affiliate.total,
      maxPages: affiliate.maxPages,
      perPage: affiliate.perPage,
      currentPage: affiliate.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchAffiliateFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),

  on(getAffiliate, (state, { id }) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(getAffiliateSuccess, (state, { affiliate }) => {
    const payload = {
      isLoaded: true,
      selectedItem: affiliate
    };
    return { ...state, ...payload };
  }),
  on(getAffiliateFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
 
);

export function affiliateReducer(state, action) {
  return _affiliateReducer(state, action);
}
